<template>
  <div>
    <div class="row">
      <div class="col-md-12 text-center">
        <div class="d-flex justify-content-center">
          <a href="/">
            <img
              class="img-fluid"
              :src="carregarLogo()"
              style="
                max-height: 170px;
                margin-bottom: 10px;
                max-width: 450px;
                width: 100%;
              "
              v-bind:class="{
                loginLogoStream1x2: retornaSite() == 'Stream1x2',
              }"
              v-if="retornaSite() !== '7live'"
            />
          </a>
        </div>
      </div>
    </div>
    <Dialog
      id="dialogCadastro"
      titulo="Novo cadastro"
      ref="dialog"
      :modal="false"
      :hideFooter="retornaSite() == '7live' ? true : false"
      :tituloCenter="true"
      :noClassFooter="false"
    >
      <form class="text-left">
        <div class="form-group row">
          <label for="nome" class="col-sm-12 col-form-label"
            >Nome Completo</label
          >
          <div class="col-sm-12">
            <input
              class="form-control"
              v-bind:class="{ 'is-invalid': itemErros.nome.status }"
              type="text"
              v-model="item.nome"
              @keyup="enterEntrar"
            />
            <div v-if="itemErros.nome.status" class="invalid-feedback">
              {{ itemErros.nome.mensagem }}
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label for="email" class="col-sm-12 col-form-label">Email</label>
          <div class="col-sm-12">
            <input
              class="form-control"
              v-bind:class="{ 'is-invalid': itemErros.email.status }"
              type="text"
              v-model="item.email"
              @keyup="enterEntrar"
            />
            <div v-if="itemErros.email.status" class="invalid-feedback">
              {{ itemErros.email.mensagem }}
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label for="senha" class="col-sm-12 col-form-label">Senha</label>
          <div class="col-sm-12">
            <input
              class="form-control"
              v-bind:class="{ 'is-invalid': itemErros.senha.status }"
              type="password"
              v-model="item.senha"
              @keyup="enterEntrar"
            />
            <div v-if="itemErros.senha.status" class="invalid-feedback">
              {{ itemErros.senha.mensagem }}
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label for="senha" class="col-sm-12 col-form-label"
            >Confirmar senha</label
          >
          <div class="col-sm-12">
            <input
              class="form-control"
              v-bind:class="{ 'is-invalid': itemErros.confirmarSenha.status }"
              type="password"
              v-model="item.confirmarSenha"
              @keyup="enterEntrar"
            />
            <div
              v-if="itemErros.confirmarSenha.status"
              class="invalid-feedback"
            >
              {{ itemErros.confirmarSenha.mensagem }}
            </div>
          </div>
        </div>
      </form>

      <template v-slot:rodape v-if="retornaSite() == '7live' ? false : true">
        <div class="d-flex justify-content-center" style="width: 100%">
          <button
            type="button"
            class="btn"
            v-bind:class="{
              'btn-primary': retornaSite() == 'Bll',
              'btn-secondary': retornaSite() == 'Weddbets',
            }"
            @click="entrar()"
          >
            Cadastrar
          </button>
        </div>
      </template>
    </Dialog>

    <div class="row" v-if="retornaSite() == 'Weddbets'">
      <div class="col col-md-12 d-flex justify-content-center">
        <span class="text-center">
          <a
            clsas="d-flex justify-content-center"
            href="https://t.me/Wedd_Bll"
            style="width: 100%; text-decoration: none"
            ><i
              class="fa fa-telegram"
              style="font-size: 36px; color: #0088cc"
            ></i>
            <h5 style="color: black; min-width: 135px">weddbets</h5></a
          ></span
        ><span class="text-center" style="margin-left: 10px" v-if="false">
          <a
            clsas="d-flex justify-content-center"
            href="https://wa.me/qr/OQN6E6SM2PURM1"
            style="width: 100%; text-decoration: none"
            ><i
              class="fa fa-whatsapp"
              style="font-size: 36px; color: #34af23"
            ></i>
            <h5 style="color: black; min-width: 135px">
              <small>41 99936-4613</small>
            </h5></a
          ></span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../includes/util.js";

import Dialog from "../components/Dialog.vue";

export default {
  name: "Login",
  components: { Dialog },
  methods: {
    carregarLogo() {
      if (this.$site == "Weddbets") {
        return "/assets/logob.png";
      }

      if (this.$site == "Bll") {
        return "/assets/logobll.png";
      }

      if (this.$site == "Stream1x2") {
        return "/assets/StreamTrader.png";
      }

      if (this.$site == "7live") {
        return "/assets/logo_stadiums.png";
      }

      return "";
    },
    retornaSite() {
      return this.$site;
    },

    async entrar() {
      //var objPagina = this;

      //* Limpa os erros
      this.itemErros = util.errosLimpar(this.itemErros);

      //* Carrega os dados
      var body = {
        nome: this.item.nome,
        email: this.item.email.toLowerCase(),
        senha: this.item.senha,
        confirmarSenha: this.item.confirmarSenha,
        indicacao: this.$route.params.idUsuario,
      };

      const apiRequest = await api.post("/usuario/cadastro", body);

      if (apiRequest.data.erro) {
        util.errosProcessar(this.itemErros, apiRequest.data.erros);
      } else {
        if (apiRequest.data.sessao && apiRequest.data.sessao.key) {
          localStorage.setItem("ckd", apiRequest.data.sessao.key);
          localStorage.setItem(
            "ckdCch",
            JSON.stringify(apiRequest.data.sessao)
          );
          window.location = "/";
          //this.$router.push({ name: "home" });
        }
      }
    },
    async enterEntrar(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        this.entrar();
      }
    },
  },
  mounted() {},
  data: function () {
    return {
      item: {
        nome: "",
        email: "",
        senha: "",
        confirmarSenha: "",
      },
      itemErros: {
        nome: { status: false, mensagem: "" },
        email: { status: false, mensagem: "" },
        senha: { status: false, mensagem: "" },
        confirmarSenha: { status: false, mensagem: "" },
      },
    };
  },
};
</script>

<style>
.loginLogoStream1x2 {
  margin-top: 30px;
}
</style>
